var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('el-menu',{ref:"elMenu",staticClass:"custom-menu",attrs:{"default-active":_vm.activeMenu,"unique-opened":true,"router":true,"background-color":"transparent","text-color":"#b0c4de","active-text-color":"#409eff"},on:{"select":_vm.changeMenu}},[_c('MenuItem',{attrs:{"item":_vm.authMenu}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }